import PropTypes from "prop-types";
import { Box } from "@mui/material";

// Tab Panel
export function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tab-panel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

// Accessibility props
export const a11yProps = (index) => ({
  id: `tab-${index}`,
  "aria-controls": `tab-panel-${index}`,
});
